import { CONTACT_EMAIL, NEW_PORTAL_URL, SHUTDOWN_DATE } from '../legacyPolicy';

const Moved = () => (
  <div className='row justify-content-center'>
    <div className='col-11 col-lg-8'>
      <div className='card card-sm'>
        <div className='card-body'>
          <h3 className='page-heading'>This area has moved</h3>
          <p>
            This area has moved to the new Lara portal. Visit <a href={NEW_PORTAL_URL}>{NEW_PORTAL_URL}</a> to continue. Only the Excel Connector remains on this
            site.
          </p>
          <p>
            This site (cloud.larasoft.global) will be turned off on {SHUTDOWN_DATE}. Please complete your move to the new portal before then. Questions? Email{' '}
            <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.
          </p>
        </div>
      </div>
    </div>
  </div>
);

export default Moved;
